var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "checkbox_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M959.936 0C995.328 0 1024 28.48 1024 64.064v895.872c0 35.392-28.48 64.064-64.064 64.064H64.064A63.904 63.904 0 0 1 0 959.936V64.064C0 28.672 28.48 0 64.064 0h895.872zm0 32H64.064a31.904 31.904 0 0 0-31.84 28.288L32 64.064v895.872c0 16.576 12.288 30.016 28.288 31.84l3.776.224h895.872a31.904 31.904 0 0 0 31.84-28.288l.224-3.776V64.064a31.904 31.904 0 0 0-28.288-31.84L959.936 32z",
    fillOpacity: 0.2
  })));
};

export default SvgCheckbox;